import type { PriorityLevel } from '@spacefill/uikit/src/components/Priority/Helpers';

// Priority values stored on logistics_cases (incidents, additional requests, …).
export const logisticsCasePriorityOutputValues: Record<PriorityLevel, string> = {
    NO_PRIORITY: 'NO_PRIORITY',
    URGENT: '40_URGENT',
    HIGH: '30_HIGH',
    MEDIUM: '20_MEDIUM',
    LOW: '10_LOW',
};

export const logisticsCasePriorityInputValues: Record<string, PriorityLevel> = {
    '40_URGENT': 'URGENT',
    '30_HIGH': 'HIGH',
    '20_MEDIUM': 'MEDIUM',
    '10_LOW': 'LOW',
};
